import Rest from '../../app/Base/Rest';

/**
 * @typedef {PlanActionRegistrationService}
 */
export default class PlanActionRegistrationService extends Rest {
	/**
	 * @type {String}
	 */
	static resource = '/planactionegistration';
}
